"use client";

import { Message } from "@/lib/core/crm/types";
import { cleanMessageBody } from "@/lib/email/safe-email-body-utils";
import { SafeEmailBody } from "./SafeEmailBody";

interface MessageContentProps {
  message: Message;
}

export function MessageContent({ message }: MessageContentProps) {
  const cleanedBody = cleanMessageBody(message.body ?? "");

  return (
    <div className="flex-1">
      <div className="rounded-lg border bg-muted/30 p-4">
        {cleanedBody ? (
          <SafeEmailBody body={message.body ?? ""} variant="full" collapseQuotedReplies />
        ) : (
          <div className="flex items-center justify-center py-8">
            <div className="text-center">
              <p className="mb-2 text-muted-foreground italic">{message.bodyPreview || "No message content available"}</p>
              <p className="text-xs text-muted-foreground">
                Message body will be loaded when viewing details
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
